import { defineStore } from 'pinia'
import { services } from '@/assets/js/config.js';
import { useHttpStore } from './httpStore';

export const useAttachmentStore = defineStore('attachmentStore', {
  state: () => ({
		attachmentCategories:[]
		// activeApprovalList:[]
  }),
  getters: {
	},
  actions: {
		getAttachmentList(params={}) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.get(`${services.attachment}attachments`, params).then((resp) => {
          httpStore.convertPaginationKeys(resp.data);
					// this.activeApprovalList = resp.data.data
          resolve(resp.data);
        }).catch(err => {
          _gNotif.cLog(err);
          reject(err);
        });
      });
    },
		
    detailAttachment(id) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.post(`${services.attachment}attachments/${id}`, params).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
          _gNotif.cLog(err);
          reject(err);
        });
      });
    },

    uploadAttachment(params) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {

				const formData = new FormData();
				Object.keys(params).forEach(key => {
				formData.append(key, params[key]);
				});

        httpStore.post(`${services.attachment}attachments`, formData, { 'Content-Type': 'multipart/form-data' }).then((resp) => {
					resolve(resp.data);
				}).catch(err => {
          _gNotif.cLog(err);
          reject(err);
        });
      });
    },

    deleteAttachment(id) {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.delete(`${services.attachment}attachments/${id}`).then((resp) => {
					resolve(resp.data);
        }).catch(err => {
          _gNotif.cLog(err);
          reject(err);
        });
      });
    },

		listAttachmentCategories() {
      const httpStore = useHttpStore();
      return new Promise((resolve, reject) => {
        httpStore.get(`${services.attachment}attachment/categories`).then((resp) => {
					this.attachmentCategories = !_gHlp.isEmpty(resp.data) ? resp.data.data : [];
          resolve(resp.data);
        }).catch(err => {
          _gNotif.cLog(err);
          reject(err);
        });
      });
    },

  }
})